module.exports = __webpack_public_path__ + "static/img/icon-customer-service.33a0eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-customer-service.png
// module id = uqNk
// module chunks = 1